// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3nIG3","title":"ClientReferral_title__rdcfL","itemText":"ClientReferral_itemText__2H2F3"};